var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card card-separator mb-2 clickable collapse-toggle" },
    [
      _c("div", { staticClass: "card-header px-3 py-2 bb-0" }, [
        _c("div", { staticClass: "row align-items-end" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 d-flex justify-content-between align-items-center",
            },
            [
              _c("div", [
                _c(
                  "h2",
                  {
                    staticClass:
                      "section-separator-title automation-separator-title-big text-primary",
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.title) + "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "h3",
                  {
                    staticClass:
                      "section-separator-title separator-subtitle text-uppercase text-light-gray",
                  },
                  [
                    _vm._v(
                      "\n            " + _vm._s(_vm.subtitle) + "\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("icon", {
                staticClass: "when-not-collapsed text-primary",
                attrs: { name: "caret-down" },
              }),
              _vm._v(" "),
              _c("icon", {
                staticClass: "when-collapsed text-primary",
                attrs: { name: "caret-right" },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }